import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/truckmodels?accountID=${accountID}`
      }))
  );
}

async function getById(truckModelID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/truckmodels/${truckModelID}`
      }))
  );
}

async function create(truckModel) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        body: JSON.stringify(truckModel),
        url: '/truckmodels'
      }))
  );
}

async function createMultiple(truckModelList) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/truckmodels/bulk',
        body: JSON.stringify(truckModelList)
      }))
  );
}

async function update(truckModel) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        body: JSON.stringify(truckModel),
        url: `/truckmodels/${truckModel.truckModelID}`
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(truckModelID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/truckmodels/${truckModelID}`
      }))
  );
}

const truckModelService = {
  getAll,
  getById,
  create,
  createMultiple,
  update,
  delete: Delete
};

export default truckModelService;
